export var lineHeight = {
    relaxed: "1.7",
    normal: "1.4",
    snug: "1.2",
    tight: "1.1",
    xtight: "0.95"
};

//# sourceMappingURL=lineHeight.js.map